import { createFileRoute } from "@tanstack/react-router";
import { SlotGrid } from "@/components/calendar/SlotGrid";
import { ExportCalendarPanel } from "@/components/calendar/ExportCalendarPanel";
import { ShieldCheck } from "lucide-react";

export const Route = createFileRoute("/dashboard/calendar")({
  head: () => ({
    meta: [
      { title: "Calendar · Heallexa" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: CalendarPage,
});

function CalendarPage() {
  return (
    <div className="space-y-6 max-w-5xl">
      <div>
        <h1 className="text-[20px] font-medium tracking-tight">Calendar</h1>
        <p className="text-[13px] text-muted-foreground flex items-center gap-1.5 mt-1">
          <ShieldCheck className="h-4 w-4 text-primary" />
          HIPAA-aligned. Patient details never leave Heallexa or appear in exported feeds.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <SlotGrid />
        <ExportCalendarPanel />
      </div>
    </div>
  );
}
